import type { ICollectionType, IMediaCard } from '@pcln/contentful-components'
import { Carousel, type CarouselContentSlide, Heading } from '@pcln/horizon'
import type { ComponentType } from 'react'

import MediaCardComponentHorizon from './MediaCardComponentHorizon'

type MediaCardCollectionProps = {
  collection?: ICollectionType<IMediaCard>
  cardNode?: ComponentType<{ content: IMediaCard }>
}

export function MediaCardCollection({
  collection,
  cardNode: CardNode = MediaCardComponentHorizon,
}: Readonly<MediaCardCollectionProps>) {
  const { headline, items } = collection ?? {}

  if (!items?.length) {
    return
  }

  const slides = items.map(
    (item, index): CarouselContentSlide => ({
      id: item.internalName ?? `media-card-${index}`,
      childrenNodes: <CardNode content={item} />,
    }),
  )

  return (
    <div className='flex flex-col gap-6'>
      {headline && (
        <Heading as='h2' palette='actionPrimary' bold>
          {headline}
        </Heading>
      )}
      <Carousel
        type='content'
        numSlides='one-two-three'
        slideWidth='same'
        dragFree={items.length > 3}
        slides={slides}
      />
    </div>
  )
}
